"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperienceSection = void 0;
const ui_1 = require("@app/component/ui");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const shift_modal_section_1 = require("../components/shift-modal-section");
const shift_context_1 = require("../shift-context");
const ExperienceSection = () => {
    const { formControl, disabledEditation } = (0, shift_context_1.useShift)();
    const { ref, ...field } = (0, react_hook_form_1.useController)({
        control: formControl,
        name: 'idealSkill',
    }).field;
    return (react_1.default.createElement(shift_modal_section_1.ShiftModalSection, { id: 'experience' },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            react_1.default.createElement(ui_1.SkillSelect, { ...field, disabled: (0, util_1.isDefined)(disabledEditation) }))));
};
exports.ExperienceSection = ExperienceSection;
